import { useNavigate } from "react-router-dom";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../app/redux/hooks";
import { paymentCheckoutAsync } from "../../../../../../app/slices/checkoutSlice/CheckoutSlice";
import { showSnackbar } from "../../../../../../app/slices/common/customSnackBar/customSnackbarSlice";
import { useState } from "react";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import RenderRazorpay from "./RazorPay";
import axios from "../../../../../../axios";
import { useEffect } from "react";
import { PAYU_URL } from "../../../../../../api/payu/Api";

                    const redirectToPayU = (params: any, payuUrl: string) => {
                      const form = document.createElement("form");
                      form.method = "POST";
                      form.action = payuUrl;

                      Object.entries(params).forEach(([key, value]) => {
                        const input = document.createElement("input");
                        input.type = "hidden";
                        input.name = key;
                        input.value = String(value ?? "");
                        form.appendChild(input);
                      });

                      document.body.appendChild(form);
                      form.submit();
                    };


export const PaymentPage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const selectedAddressId = useAppSelector(
    (state) => state.CheckoutState.selectedAddressId
  );
  const selectedDeliverySlot = useAppSelector(
    (state) => state.CheckoutState.selectedDeliverySlot
  );
  const selectedDeliveryType = useAppSelector(
    (state) => state.CheckoutState.selectedDeliveryType
  );
  const selectedDeliveryDate = useAppSelector(
    (state) => state.CheckoutState.selectedDeliveryDate
  );
  const optIn = useAppSelector((state) => state.CheckoutState.opt_in);
  const { addTocart } = useAppSelector((state) => state.CartState);
  const [selectedPaymentModeId, setSelectedPaymentModeId] = useState<
    number | null
  >(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Set default payment mode when available payment modes load
  useEffect(() => {
    const modes = addTocart?.available_payment_modes || [];
    if (modes.length > 0) {
      // prefer the first mode if none selected yet
      if (!selectedPaymentModeId) setSelectedPaymentModeId(Number(modes[0].id));
    }
  }, [addTocart?.available_payment_modes, selectedPaymentModeId]);
  // Format selected delivery date
  const startDateString = selectedDeliveryDate
    .toString()
    .split(" to ")[0]
    .trim();
  const formattedSelectedDate = new Date(startDateString)
    .toISOString()
    .split("T")[0];

  // Handle payment click
  const handlePaymentClick = async () => {
    try {
      const payload: any = {
        address_id: Number(selectedAddressId),
        pickup: selectedDeliveryType === "pickup",
        deliver_date: formattedSelectedDate,
        opt_in: optIn,
        delivery_mode: selectedPaymentModeId,
      };

      if (!payload.pickup) {
        payload.delivery_slot = Number(selectedDeliverySlot);
      }

      const response = await axios.post("https://navya.svpstaging.com/orders/checkout/", payload);

      console.log('Response Data:', response.data);
      debugger;

      if (selectedPaymentModeId === 1 && response.data) {
        dispatch(
          showSnackbar({
            message: "Order placed successfully with COD",
            severity: "success",
            autoHide: 3000,
          })
        );
        navigate("/order-confirmation");
      } else if (typeof response.data === "string" && response.data.includes("payuForm")) {
        // Handle legacy HTML form response
        const tempContainer = document.createElement("div");
        tempContainer.innerHTML = response.data;
        const form = tempContainer.querySelector("form[name='payuForm']") as HTMLFormElement;
        
        if (form) {
          document.body.appendChild(form);
          form.submit();
        } else {
          dispatch(
            showSnackbar({
              message: "Failed to initiate PayU payment",
              severity: "error",
            })
          );
        }
      } else if (
        response.data?.status === 1 &&
        response.data?.params &&
        response.data?.params?.key
      ) {
        // Handle new JSON response format with payu_url and params
        console.log("PayU params found, redirecting...", response.data.params);
        redirectToPayU(
          response.data.params,
          response.data.payu_url
        );
      } else {
        dispatch(
          showSnackbar({
            message: "Failed to initiate PayU payment",
            severity: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        showSnackbar({ message: "Something went wrong.", severity: "error" })
      );
    }
  };

  return (
    <div className="d-flex flex-column">
      <h2>Choose Payment Method</h2>
      {/* Render available payment modes as radio buttons */}
      <FormControl component="fieldset" sx={{ mb: 2 }}>
        <RadioGroup
          aria-label="payment-mode"
          name="payment-mode"
          value={
            selectedPaymentModeId !== null ? String(selectedPaymentModeId) : ""
          }
          onChange={(e) => setSelectedPaymentModeId(Number(e.target.value))}
        >
          {(addTocart?.available_payment_modes || []).map((mode: any) => (
            <FormControlLabel
              key={mode.id}
              value={String(mode.id)}
              control={<Radio />}
              label={mode.mode_name}
            />
          ))}
        </RadioGroup>
      </FormControl>

      <button
        className="tf-btn btn-fill animate-hover-btn radius-3 w-75 justify-content-center orange-b"
        onClick={handlePaymentClick}
        disabled={!selectedPaymentModeId}
      >
        {selectedPaymentModeId == 1 ? "Confirm Order" : "Proceed to Pay"}
      </button>
    </div>
  );
};
